export default __webpack_public_path__ + "static/media/JE-talent.9cebca18.png";